import { AUTH_TOKEN, LOGIN_TYPE } from '@/helpers/constants/app';
import { removeFbSession } from '@/helpers/FbSession';
/**
 * Implement Vuex Store Namespaced Modules
 * https://vuex.vuejs.org/guide/modules.html#namespacing
 * Add Namespace into modules to avoid Module Store Objects conflicts;
 */
const authStates = {
    token: null,
    authenticated: false,
    fromAppsDashboard: false,
    loginType: localStorage.getItem(LOGIN_TYPE),
};
const getters = {
    token(state) {
        return state.token;
    },
    role(state) {
        return state.loginType;
    },
    authenticated(state) {
        return state.authenticated;
    },
    fromAppsDashboard(state) {
        return state.fromAppsDashboard;
    },
    isStoreManagerLogin(state) {
        return state.loginType === 'store_manager';
    },
};
const mutations = {
    // commit('session/authenticate')
    authenticate(state, payload) {
        state.authenticated = true;
        state.token = payload.token;
        state.loginType = payload.loginType;
        // createCookie(AUTH_TOKEN, payload.token);
        // createCookie(LOGIN_TYPE, payload.loginType);
        sessionStorage.setItem(AUTH_TOKEN, payload.token);
        sessionStorage.setItem(LOGIN_TYPE, payload.loginType);
    },
    // commit('session/logout')
    logout(state) {
        state.token = null;
        state.authenticated = false;
        state.loginType = null;
        // deleteCookie(AUTH_TOKEN);
        // deleteCookie(LOGIN_TYPE);
        sessionStorage.removeItem(AUTH_TOKEN);
        sessionStorage.removeItem(LOGIN_TYPE);
        removeFbSession();
    },
    fromAppsDashboard(state, val) {
        state.fromAppsDashboard = val;
    },
};
export default {
    namespaced: true,
    state: authStates,
    getters,
    mutations,
};
